import React from "react";
import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const WithdrawalList = () => {
  const navigate = useNavigate();

  return (
    <Box p={5} maxW="700px" mx="auto">
      <VStack align="stretch" spacing={4}>
        <Heading size="md">Stripe Payouts</Heading>
        <Text color="gray.700">
          Payouts are handled through Stripe Connect. Use banking setup to manage payout
          details and account readiness.
        </Text>
        <Button colorScheme="orange" onClick={() => navigate("/bank")}>
          Go to Banking Setup
        </Button>
      </VStack>
    </Box>
  );
};

export default WithdrawalList;
